// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1j5Ai","col":"styles_col__1OLpq"};